import { TranslationMap } from '@trimble-gcs/i18n-types';

export function scandataEmptyTranslations() {
  return {
    title: {
      text: $localize`:@@scandataEmpty.title:No Data`,
      desc: 'Title of the message displayed when there is no scan data to display.',
    },
    noUploads: {
      text: $localize`:@@scandataEmpty.noUploads:Looks like you haven't added any data yet.`,
      desc: 'Message displayed when no scan data has been added to the project yet.',
    },
    noFilterResults: {
      text: $localize`:@@scandataEmpty.noFilterResults:No results found with the applied filter.`,
      desc: 'Message displayed when no scan data meets the filter criteria.',
    },
    noGeolocated: {
      text: $localize`:@@scandataEmpty.noGeolocated:No geolocated data or CRS missing.`,
      desc:
        'Message displayed when the user chose to view only geolocated data, ' +
        'but there are no results that meet that citerion. ' +
        'In this context "geolocated data" is a dataset that contains an embedded ' +
        'Coordinate Reference System (CRS), which is used within the appplication ' +
        'to place the dataset in the correct position on the map in the Map View.',
    },
    noSelected: {
      text: $localize`:@@scandataEmpty.noSelected:No data was selected.`,
      desc:
        'Message displayed when the user chose to view only data that has been selected by clicking ' +
        'on one or more rows, but there is no such selection at present. ',
    },
    noRecycled: {
      text: $localize`:@@scandataEmpty.noRecycled:Recycle bin is empty.`,
      desc: 'Message displayed when there are no scans in the recycle bin.',
    },
  } satisfies TranslationMap;
}
